import { Icon, type IconProps } from "./icon";

/** Overview: the project's panels side by side, each a summary at a glance. */
export function OverviewIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <rect x="3" y="3" width="6" height="8" rx="1.25" />
      <rect x="11" y="3" width="6" height="4.5" rx="1.25" />
      <rect x="11" y="9.5" width="6" height="7.5" rx="1.25" />
      <rect x="3" y="13" width="6" height="4" rx="1.25" />
    </Icon>
  );
}
